import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  html, body {
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    height: 100%;
    width: 100%;
  }

  body.fontLoaded {
    font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }

  #root {
    background-color: #fafafa;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    width: 100%;
  }
  
  .ant-app {
      flex: 1;
  }

  p,
  label {
    line-height: 1.5em;
  }

  .page-loading {
    position: fixed;
    bottom: 5px;
    right: 0px;
    z-index: 1000;
    text-decoration: blink;
  }
  .link-password-recover {
    flex: 1;
  }
  .link-password-recover a {

  }
  .link-password-recover a:hover {
    text-decoration: underline;
  }
  .ant-table-row {
    cursor: pointer;
  }
  div.public-layout-log-container {
    width: 80%;
    margin: 0px auto;
    padding: 40px;
    border-bottom: solid 1px lightgray;

  }
  div.public-layout-log-container img {
    width: 100%;
  }
  .accented-shadow {
    box-shadow: rgba(0,0,0,0.15) 0 2px 8px;
  }
  .custom-date-setter {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 90%;
    margin: 2px 0px 3px;
  }
  li.ant-menu-item-disabled {
    cursor: unset;
  }

  // previously in astech-theme.less
  .ant-message-custom-content {
      align-items: center;
      display: flex;
  }

  .ant-form-item {
      margin-bottom: 14px;
  }

  .messages-list .ant-list-item {
      padding: 12px 24px;
  }

  .new-modal-form div.reverse-margin {
      margin-top: 0px;
      margin-bottom: 12px;
  }
  .new-modal-form div.input-label {
      font-weight: bold;
      margin-bottom: 12px;
  }
  .new-modal-form fieldset {
      margin-top: 12px;
      padding: 0px 18px 18px;
      margin-bottom: 0px;
      border: solid 1px lightgray;
  }
  .new-modal-form legend {
      font-size: 1.25em;
      display: inline-block;
      padding: 0px 18px;
      width: auto;
      margin-bottom: 0px;
  }
`;

export default GlobalStyle;